import styled from '@emotion/styled';

const Divider = styled.div<{ height?: number; margin?: number }>`
  border-left: 1px solid var(--dk-line, #e7e9ec);
  height: ${({ height }) => (height ? `${height}px` : '12px')};
  margin-left: ${({ margin }) => (margin ? `${margin}px` : '24px')};
  margin-right: ${({ margin }) => (margin ? `${margin}px` : '24px')};
`;

const ContentsLayout = styled.div<{ isFocus: boolean }>`
  position: absolute;
  margin-top: 8px;
  min-width: 402px;
  width: 100%;
  border-radius: 6px;
  border: 1px solid #000;
  background: var(--dk-bg, #fff);
  box-shadow: 0px 16px 32px 0px rgba(0, 0, 0, 0.08);
  visibility: ${({ isFocus }) => (isFocus ? 'visible' : 'hidden')};
  opacity: ${({ isFocus }) => (isFocus ? '1' : '0')};
  //transition: all 0.2s ease-in;
  z-index: 1;
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-top: 16px;
`;

const SearchHeaderContainer = styled.div`
  padding: 16px;
  display: flex;
  gap: 24px;
  border-bottom: 1px solid black;
  align-items: center;
`;
const StyledHeaderTitle = styled.div``;

const StyledLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
`;

export {
  Divider,
  ContentsLayout,
  ContentContainer,
  SearchHeaderContainer,
  StyledHeaderTitle,
  StyledLabel,
};
